import React from 'react'
import { ReactSVG } from 'react-svg'
import { formatNumber } from '../utils/countDictinary'

function Balls({
  balls,
  className,
  icon,
  text
}: {
  balls: number
  className?: string
  icon: string
  text?: boolean
}): React.ReactElement {
  return (
    <div className={`balls ${className ?? ''}`.trim()}>
      <ReactSVG wrapper={'span'} src={icon}></ReactSVG>
      <span className={'text-body-small'}>
        {balls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
          (text ? ` ${formatNumber(balls, 'balls')}` : '')}
      </span>
    </div>
  )
}

export default Balls
